export function makeFactAddressItems(data) {
    const address = data?.dispatch ?? {};

    return [
        {
            label: "Tipo",
            value: address?.dispatch_facttype ?? "",
        },
        {
            label: "Local pré-cadastrado",
            value: address?.dispatch_factplace ?? "",
        },
        {
            label: "Logradouro",
            value: address?.dispatch_factstreet ?? "",
        },
        {
            label: "Número",
            value: address?.dispatch_factnumber ?? "",
        },
        {
            label: "Bairro",
            value: address?.dispatch_factneighborhood ?? "",
        },
        {
            label: "Cruzamento",
            value: address?.dispatch_factcrossroads ?? "",
        },
        {
            label: "Ponto de referência",
            value: address?.dispatch_factreferencepoint ?? "",
        },
        {
            label: "Município",
            value: address?.dispatch_factcity ?? "",
        },
        {
            label: "Setores",
            value: address?.dispatch_sectors ?? "",
        },
    ];
}